import { ConfigState } from './types';

export const envNameSet = (state: ConfigState, name: string): void => {
  state.name = name;
};
